<div class="actions" *ngIf="visible">
    <ion-button (click)="onClick('register')" *ngIf="isButton" color="light">{{ renderValue }}</ion-button>

    <ion-icon *ngIf="!isButton" name="checkmark"></ion-icon>
    <span *ngIf="!isButton">{{ renderValue }}</span>

    <ion-button (click)="expandMenu()" *ngIf="!isButton" size="small" fill="clear">
        <ion-icon slot="icon-only" name="ellipsis-vertical"></ion-icon>
    </ion-button>
</div>
